module.exports = __webpack_public_path__ + "img/ics_o_box.d34e48dc.svg";